var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-wrapper" }, [
    _c("div", { staticClass: "links" }),
    _vm._v(" "),
    _c("p", { staticClass: "mt10 mb10" }, [
      _c(
        "a",
        {
          staticClass: "font-black",
          attrs: { href: _vm.icpInfo.gwAbNoLink, target: "_blank" }
        },
        [_vm._v(_vm._s(_vm.icpInfo.icpNo || ""))]
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mt10 mb10" }, [
      _vm._v(_vm._s(_vm.icpInfo.copyRight))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c372111e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c372111e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/user/Login-foot.vue
// module id = 3475
// module chunks = 1